import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { errMsg, money, useApi } from "../lib/api";

export const BuyButton = ({ kind, itemId, price, label, testId, className = "" }) => {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const buy = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { kind, item_id: itemId, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(errMsg(e, "Could not start checkout"));
      setBusy(false);
    }
  };
  return (
    <Button
      data-testid={testId || `buy-${kind}-${itemId || "membership"}`}
      onClick={buy}
      disabled={busy}
      className={`bg-yellow-400 text-black font-bold hover:bg-yellow-300 transition-colors ${className}`}
    >
      {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {label || `Buy · ${money(price)}`}
    </Button>
  );
};
